import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import { getPartnerCardSx } from '../../partnerDashboardTheme';
import { usePortalTokens } from '../../../../styles/usePortalTokens';

const ICONS = {
  rsvps: GroupsOutlinedIcon,
  paid: PaymentsOutlinedIcon,
  noShow: PersonOffOutlinedIcon,
  attendance: HowToRegOutlinedIcon,
};

const PartnerEventStatCard = ({ title, value, iconKey, iconBg, iconColor }) => {
  const Icon = ICONS[iconKey] ?? GroupsOutlinedIcon;
  const portal = usePortalTokens();

  return (
    <Card elevation={0} sx={{ ...getPartnerCardSx(portal), height: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '8px',
              bgcolor: iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Icon sx={{ fontSize: 22, color: iconColor }} />
          </Box>
          <Typography
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              fontSize: '0.8125rem',
              lineHeight: 1.3,
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: '1.625rem',
            fontWeight: 700,
            color: 'text.primary',
            lineHeight: 1.1,
          }}
        >
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default PartnerEventStatCard;
